import React from 'react'
import { useSelector } from 'react-redux'

import Wrapper from './Wrapper'
import { Button } from 'components/base'

import { selectors as ConfigSelectors } from 'data/config'

export default function UnknownError() {
  const desktopDownloadURL = useSelector(ConfigSelectors.getDesktopDownloadUrl)
  return (
    <Wrapper
      image={null}
      goBackButton={
        <Button.Primary href={desktopDownloadURL}>
          Download desktop app
        </Button.Primary>
      }
    >
      Internet Explorer is not supported by Slite
    </Wrapper>
  )
}
